(function () {
    'use strict';
    angular.module('app').controller('AccountingSurchargeProfileSurchargeDetailsController', AccountingSurchargeProfileSurchargeDetailsController);

    AccountingSurchargeProfileSurchargeDetailsController.$inject = [
        '$uibModalInstance',
        'selectedSurcharge', 
        'savedSurcharges',
        'ConfirmationModalFactory',
        '$rootScope'
    ];

    function AccountingSurchargeProfileSurchargeDetailsController(
        $uibModalInstance, 
        selectedSurcharge, 
        savedSurcharges,
        ConfirmationModalFactory,
        $rootScope
    ) {
        const vm = this;

        vm.surchargeRaw     = angular.copy(selectedSurcharge);
        vm.currency         = angular.getObjVal($rootScope.GlobalProfile, 'office.currency');
        vm.valueTypeFix     = 'FIX'; 
        vm.valueTypePercent = 'PERCENT'; 

        vm.isNameInUse        = isNameInUse;
        vm.setFeeValueType    = setFeeValueType; 
        vm.setMarginValueType = setMarginValueType
        vm.save               = save; 
        vm.cancel             = cancel;
        
        const priorityNumberAlreadyInUseWarning = new ConfirmationModalFactory({}, {
            message: 'messages.warning.priorityNumberAlreadyInUse.MESSAGE', 
            code:    'messages.warning.priorityNumberAlreadyInUse.CODE'   
        });

        init();

        /**
         * @function    init
         * @description Initialize all methods that needed to be run when the controller is initialized. 
         * 
         */
        function init() {
            generatePriorityValues();
            createSurchargeDataObject();
        }

        /**
         * @function    createSurchargeDataObject
         * @description Create a Surcharge Object using the surcharge data passed in the controller parameter. 
         *              If there is not surcharge object passed initialize all the Surcharge Object fields as null.  
         */
        function createSurchargeDataObject() {
            vm.surcharge = {
                surchargeInternalName   :selectedSurcharge ? selectedSurcharge.surchargeInternalName : null, 
                priority                :selectedSurcharge ? selectedSurcharge.priority : vm.priorityNumbers[0],
                fee                     :selectedSurcharge ? selectedSurcharge.fee : null, 
                margin                  :selectedSurcharge ? selectedSurcharge.margin : null,
                marginValueType         :selectedSurcharge ? selectedSurcharge.marginValueType : vm.valueTypeFix, 
                feeValueType            :selectedSurcharge ? selectedSurcharge.feeValueType : vm.valueTypeFix,
                serviceCodeSurcharge    :selectedSurcharge ? selectedSurcharge.serviceCodeSurcharge : null
            }
        }

        /**
         * @function    generatePriorityValues
         * @description Generate values for priority select input field. But don't include the already in use priority numbers 
         *              if the passed selectedSurcharge data in the controller is null or undefined.
         * 
         */
        function generatePriorityValues(){
            vm.priorityNumbers = [...Array(10).keys()].map(priority => ++priority);
            if(!selectedSurcharge){
                savedSurcharges.forEach(surcharge => {
                    const foundIndex = vm.priorityNumbers.indexOf(surcharge.priority); 
                    if(foundIndex != -1) {
                        vm.priorityNumbers.splice(foundIndex, 1);
                    }
                });
            }
        }

        /**
         * @function    isNameInUse
         * @description Check if the surcharge inter name is already in use. 
         *              If the name is already in use return true otherwise return false.
         * 
         * @param       { string } surchargeInternalName
         * @return      { boolean } 
         */
        function isNameInUse(surchargeInternalName){
           const duplicateName = savedSurcharges.filter(surcharge => {
               return (surcharge.surchargeInternalName == surchargeInternalName) && (vm.surchargeRaw.surchargeInternalName != surcharge.surchargeInternalName);
           });
           return duplicateName.length > 0 ? true : false;
        }

        /**
         * @function    setFeeValueType
         * @description Set Fee Value Type 
         * 
         * @param       {string} valueType
         */
        function setFeeValueType(valueType){
            vm.surcharge.feeValueType = valueType; 
        }

        /**
         * @function    setMarginValueType
         * @description Set margin value type
         * 
         * @param       {string} valueType
         */
        function setMarginValueType(valueType){
            vm.surcharge.marginValueType = valueType
        }

        /**
         * @function    save
         * @description We are not realy saving any data in this method. We only close the modal box and 
         *              pass the generated data to the modal instance which can be later accessed 
         *              by the controller or service that is initilizing this controller, but before passing it 
         *              we check first if the form is valid we don't want to pass invalid data.
         * 
         * @param {form Object} form
         */
        function save(form){
            form.$setSubmitted();
            if(form.$invalid) {
                return false; 
            }

            const indexFound = isPriorityNumberIsInUse();
            if(indexFound != null){
                priorityNumberAlreadyInUseWarning.getInstance().result.then(cond => {
                    if(cond){
                        $uibModalInstance.close({
                            surchargeData : vm.surcharge, 
                            surchargeOriginalData: vm.surchargeRaw
                        }); 
                    }
                });
            }
            else {
                $uibModalInstance.close({
                    surchargeData : vm.surcharge
                }, null);
            }
        }

        /**
         * @function    checkIfPriorityNumberIsInUse
         * @description Check if the priority number is already in use and 
         */
        function isPriorityNumberIsInUse(){
            let index = null; 
            for(let i = 0; i < savedSurcharges.length; i++) {
                const surchargeData = savedSurcharges[i]; 
                if((surchargeData.priority === vm.surcharge.priority) && (vm.surcharge.surchargeInternalName !== surchargeData.surchargeInternalName)) {
                    index = i; 
                    break; 
                }
            }
            return index;
        }
        
        /**
         * @function    cancel
         * @description Close the modal box but don't pass any data in the modal instance.
         * 
         */
        function cancel() {
            $uibModalInstance.dismiss();
        }
    }
})();


// WEBPACK FOOTER //
// ./js/controllers/accounting/AccountingSurchargeProfileSurchargeDetailsController.js